import {Col} from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

export default function SkeletonFileBox() {
  return (
    <Col lg={6}>
      <Skeleton count={3} height={30} />
    </Col>
  )
}
